import { AxleChip, ChipsInRows } from '@/components/displayFields/chips';
import { ReturnComponent } from '@/utils/reactTypes';
import { Link } from '@mui/material';
import { MatchingCriterionModality } from 'gql-types';
import { useState } from 'react';

import { NONE_TEXT } from '../displayFields/AxleInfoField';
import { MatchingCriterionNeed } from './MatchingCriterionChips.fragments';
import { MatchingCriterionNeedFragment } from './MatchingCriterionChips.fragments.gql.types';

export { MatchingCriterionNeed };

const PREVIEW_COUNT = 5;

const MODALITY_RANK: Record<MatchingCriterionModality, number> = {
    [MatchingCriterionModality.REQUIRED]: 0,
    [MatchingCriterionModality.PREFERRED]: 1,
};

export const MatchingCriterionChips = ({
    assignments,
    previewCount = PREVIEW_COUNT,
}: {
    assignments: MatchingCriterionNeedFragment[];
    previewCount?: number;
}): ReturnComponent => {
    const [showAll, setShowAll] = useState(false);

    if (assignments.length === 0) {
        return <>{NONE_TEXT}</>;
    }

    const ordered = [...assignments].sort(
        (a, b) => MODALITY_RANK[a.criterion.modality] - MODALITY_RANK[b.criterion.modality],
    );

    const total = ordered.length;
    const shown = showAll ? ordered : ordered.slice(0, previewCount);
    const canToggle = total > previewCount;

    return (
        <ChipsInRows>
            {shown.map(({ id, criterion }) => (
                <AxleChip
                    key={id}
                    label={criterion.displayName}
                    tooltip={criterion.description}
                    variant={
                        criterion.modality === MatchingCriterionModality.PREFERRED
                            ? 'outlined'
                            : 'filled'
                    }
                />
            ))}
            {canToggle && (
                <Link
                    component='button'
                    type='button'
                    variant='caption'
                    onClick={() => setShowAll((prev) => !prev)}
                    aria-expanded={showAll}
                    sx={{ ml: 0.5 }}
                >
                    {showAll ? 'Show less' : `+ Show all ${total}`}
                </Link>
            )}
        </ChipsInRows>
    );
};
